import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";
import { Card, CardContent } from "@/components/ui/card";
import { disclaimerSections } from "@/data/legalPages";

const sections = disclaimerSections;

export default function Disclaimer() {
  return (
    <>
      <SEOHead
        title="Disclaimer | Theorieaanbieders.nl"
        description="Disclaimer van Theorieaanbieders.nl over de juistheid van informatie, CBR-slagingscijfers, externe links, advertenties en aansprakelijkheid."
        canonicalUrl="https://theorieaanbieders.nl/disclaimer"
      />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 container mx-auto px-4 pt-24 pb-12">
          <div className="max-w-3xl mx-auto space-y-6">
            <h1 className="text-4xl font-bold">Disclaimer</h1>
            {sections.map((s) => (
              <Card key={s.title}>
                <CardContent className="p-6 space-y-2">
                  <h2 className="text-xl font-bold">{s.title}</h2>
                  <p className="text-foreground/80 leading-relaxed">{s.text}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}
